import { render, staticRenderFns } from "./TableCellExpand.vue?vue&type=template&id=50540114&scoped=true&"
import script from "./TableCellExpand.vue?vue&type=script&lang=js&"
export * from "./TableCellExpand.vue?vue&type=script&lang=js&"
import style0 from "./TableCellExpand.vue?vue&type=style&index=0&id=50540114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50540114",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
